import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-resize_noll",
  "use": "icon-resize_noll-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"icon-resize_noll\"><path fill=\"#fff\" d=\"M23.112 14.173L33.48 3.806v5.122h2.232V1.116C35.712.5 35.212 0 34.596 0h-7.812v2.232h5.122L21.54 12.6zM8.928 35.712V33.48H3.806l10.367-10.368-1.573-1.584L2.232 31.906v-5.122H0v7.812c0 .616.5 1.116 1.116 1.116z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol